import { render } from "./FilterSidebarInProgressItems.vue?vue&type=template&id=06095f49&scoped=true"
import script from "./FilterSidebarInProgressItems.vue?vue&type=script&lang=js"
export * from "./FilterSidebarInProgressItems.vue?vue&type=script&lang=js"

import "./FilterSidebarInProgressItems.vue?vue&type=style&index=0&id=06095f49&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06095f49"]])

export default __exports__